"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tag = exports.trim = exports.expand = exports.traitId = void 0;
var prefix = /^\w0*/;
var pattern = /^(?<prefix>[spti])0*(?<id>\d+)/i;
function traitId(_a) {
    var space = _a.space, property = _a.property;
    return space + "|" + property;
}
exports.traitId = traitId;
function expand(prefix, number) {
    return "" + prefix + number.toString().padStart(6, '0');
}
exports.expand = expand;
function trim(id) {
    return id.replace(prefix, '');
}
exports.trim = trim;
function tag(input) {
    var match = input.match(pattern);
    if (!match || !match.groups) {
        return null;
    }
    var id = parseInt(match.groups.id);
    switch (match.groups.prefix.toUpperCase()) {
        case 'S':
            return { kind: 'space', id: id };
        case 'P':
            return { kind: 'property', id: id };
        case 'T':
        case 'I':
            return { kind: 'theorem', id: id };
        default:
            return null;
    }
}
exports.tag = tag;
